import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FirmasComponent } from './firmas/firmas.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [FirmasComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [FirmasComponent]
})
export class FirmasModule { }